import { render, staticRenderFns } from "./PeerGroupName.vue?vue&type=template&id=14e64a51&scoped=true&"
import script from "./PeerGroupName.vue?vue&type=script&lang=js&"
export * from "./PeerGroupName.vue?vue&type=script&lang=js&"
import style0 from "./PeerGroupName.vue?vue&type=style&index=0&id=14e64a51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e64a51",
  null
  
)

export default component.exports
import {QBtn,QTabs,QTab,QTabPanels,QTabPanel,QDialog,QCard,QCardSection,QCardActions,QInnerLoading,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QTabs,QTab,QTabPanels,QTabPanel,QDialog,QCard,QCardSection,QCardActions,QInnerLoading})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
